angular.module('mx.SolutionBuilderAgent').service('mx.SolutionBuilderAgent.ContextSelectionService', ContextSelectionService);

ContextSelectionService.$inject = [
	'$q',
	'mx.internationalization',
	'mx.shell.EventService',
	'mx.shell.ContextService',
	'mx.shell.SidePanelService',
	'mx.shell.SidePanelActionsService',
	'mx.shell.DetailsView',
	'mx.shell.SearchProviderService',
];

function ContextSelectionService($q, i18n, eventService, contextService, sidePanelService, sidePanelActionsService, DetailsView, searchService) {
	let selectionView;
	let reactOnContextSelection = false;

	const service = {
		enableReactionOnContextSelection: enableReactionOnContextSelection,
		showSelection: showSelection,
	};

	eventService.subscribeGlobal(mx.shell.EventCodes.ObjectSelectionChanged, handleChangingSelection);

	return service;

	function getSelectionView() {
		selectionView =
			selectionView ||
			new DetailsView({
				id: 'selection',
				name: 'selection',
				headerTitle: i18n.get('shell.common.selection'),
				templateUrl: 'workspaces/SolutionBuilderAgent/layouts/context-selection-view/context-selection-view.html',
				controller: 'mx.SolutionBuilderAgent.ContextSelectionViewController',
			});
		selectionView.locals.view = selectionView;
		selectionView.visible = true;

		return selectionView;
	}

	function handleChangingSelection() {
		let selectionView = getSelectionView();

		if (isSelectionTabPresent()) {
			sidePanelService.addView(selectionView).catch(mx.logCatch);
			sidePanelActionsService.calculateCommonActions(contextService.selectedObjects).then(function (actions) {
				selectionView.__actions = actions;

				const resetSelectionAction = new mx.shell.Action('reset-selection', i18n.get('solutionBuilderAgent.layouts.context-selection-view.resetSelection'), 'clear');
				resetSelectionAction.controller = resetSelectionActionCtrl;
				selectionView.__actions.unshift(resetSelectionAction);
			});
		} else {
			sidePanelService.closeView(selectionView);
			selectionView = null;
		}
	}

	function showSelection() {
		const selectionView = getSelectionView();

		if (isSelectionTabPresent()) {
			return sidePanelService.addView(selectionView);
		} else {
			return $q.reject(mx.noLogCatchMessage('selection tab is not present'));
		}
	}

	function isSelectionTabPresent() {
		return reactOnContextSelection && contextService.selectedObjects.length > 0;
	}

	function resetSelectionActionCtrl() {
		return {
			execute: function () {
				searchService.currentSearch().dataQueryList.clearSelection();
			},
		};
	}

	/**
	 * @ngdoc method
	 * @name mx.shell.SidePanelService#enableReactionOnContextSelection
	 *
	 * @description
	 * Set an 'reactOnContextSelection' flag to 'true',
	 * so SidePanel should be activated automatically
	 * when {@ref mx.shell.ContextService mx.shell.ContextService} get some data.
	 *
	 * @param {boolean} `flag` - if true then SidePanel should be activated automatically
	 *        when {@ref mx.shell.ContextService mx.shell.ContextService} get some data.
	 * @param {$scope} `scope` - corresponding controller's `$scope`.
	 *        If controller's scope was passed then ones this scope is destroyed
	 *        the flag will be set to false and all views will be closed automatically.
	 *        Otherwise - it's need to manage it manually.
	 */
	function enableReactionOnContextSelection(flag, scope) {
		reactOnContextSelection = flag;
		if (scope) {
			scope.$on('$destroy', function () {
				enableReactionOnContextSelection(false);
			});
		}
	}
}
